<div class="row">
    <ng-container *ngFor="let claimType of claimTypesList?.items; let idx = index">
        <div class="col-sm-6">
            <div class="row mb-4">
                <div class="col-sm-10">
                    <div class="smp-title mb-3">{{ claimType.displayName }}</div>

                    <smp-dropzone class="full-width"
                                  [idPrefix]="(idPrefix + 'claim_type_' + idx + '.dropzone.')"
                                  [label]="'work_instructions.btn.add_work_instruction' | translate"
                                  [addButtonLabel]="'work_instructions.btn.add_work_instruction' | translate"
                                  [acceptedFiles]="acceptedFileTypes"
                                  [multi]="true"
                                  (filesSelected)="onFilesSelected($event, claimType)"
                                  [hasContent]="fileMetaCategoryList?.getFilesByCategory(claimType.id)?.hasItems">

                        <file-operation-list [idPrefix]="(idPrefix + 'claim_type_' + idx + '.')"
                                             [fileMetaList]="fileMetaCategoryList?.getFilesByCategory(claimType.id)"
                                             [withIconAvatars]="true"
                                             (view)="viewFile($event)"
                                             (download)="downloadFile($event)"
                                             (delete)="deleteFile(claimType, $event)"
                                             [disabled]="disabled">
                        </file-operation-list>

                    </smp-dropzone>
                </div>

                <div class="col-sm-2"></div>
            </div>
        </div>
    </ng-container>
</div>
